import type { TaskDefinition } from '../../../config/types';
import { onboardingTasks, reviewTeams } from '../../../config/constants';

export const scheduledPersonalProperty: TaskDefinition = {
  taskName: onboardingTasks.NeedScheduledPersonalPropertyImages,
  config: {
    staffDisplayName: 'Scheduled personal property inventory',
    appcuesModalId: '9570ff2c-f404-479f-b11c-72373cc01eb5',
    reviewTeam: reviewTeams.processing,
    daysAllowed: 15,
    enabled: true,
    account: {
      toastMessage: 'Your scheduled personal property inventory documents have been submitted for review.',
      content: ({ affectedPolicies, daysAllowed, brandName }) => ({
        title: 'Scheduled personal property inventory',
        incompleteSubtitle:
          'To keep your coverage, supply photos and appraisal documents of your scheduled personal property.',
        completedSubtitle: `You have successfully submitted for review the scheduled personal property inventory photos for policy ${affectedPolicies}.`,
        actionLabel: 'Submit now',
        contentSections: [
          {
            title: 'How does this work?',
            body: `We'll guide you through what proof we need from you—four total photos and an appraisal or receipt for each insured item. Once submitted, your proof will be reviewed by a ${brandName} representative.`
          },
          {
            title: 'When do I need to submit these documents?',
            body: `You have ${daysAllowed} days from your policy effective date to turn in the proof listed above. Without these documents, we'll have to remove coverage of your scheduled personal property.`
          }
        ]
      })
    }
  }
};
